import { ChevronDown, UserIcon } from 'lucide-react';
import { FC, useEffect, useRef, useState } from 'react';
import { UserMenuDropDown } from './UserMenuDropdown';

export const UserActionsMenu: FC = () => {
  const profileMenuRef = useRef<HTMLDivElement | null>(null);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target as Node)
      ) {
        setIsProfileMenuOpen(false);
      }
    };

    if (isProfileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isProfileMenuOpen]);

  return (
    <div className="relative" ref={profileMenuRef}>
      <button
        type="button"
        onClick={() => setIsProfileMenuOpen((current) => !current)}
        className="flex h-9 items-center gap-1 rounded-full bg-gray-200 px-2 text-gray-700 transition-colors hover:bg-gray-300"
        title="Profile"
      >
        <span className="grid h-7 w-7 place-items-center rounded-full bg-emerald-700 text-white">
          <UserIcon size={16} />
        </span>
        <ChevronDown size={14} className="text-gray-500" />
      </button>

      {isProfileMenuOpen && (
        <UserMenuDropDown onOpenChange={setIsProfileMenuOpen} />
      )}
    </div>
  );
};
